import React from 'react'
import LandingPageHeader from '../components/LandingPageHeader'
import LandingPageHome from '../components/LandingPageHome'
import LandingPageFooter from '../components/LandingPageFooter'

import './LandingPage.css'

function LandingPage({ isDarkMode, onToggleTheme }) {
  return (
    <div className="landing-page">
        <LandingPageHeader isDarkMode={isDarkMode} onToggleTheme={onToggleTheme}/>
        <LandingPageHome/>
        <LandingPageFooter/>
    </div>
  )
}

export default LandingPage
